export enum ETagLabel {
    test_lesson = 'Контрольная работа',
    online_lesson = 'Онлайн-занятие',
    selfpreparation_lesson = 'Самоподготовка',
    assembly = 'Встреча с родителем',
    course_group_tag = '',
}

export enum ETagMainColor {
    test_lesson = '#2F929A',
    online_lesson = '#0088E9',
    selfpreparation_lesson = '#e5a139',
    assembly = '#8F4AB0',
    course_group_tag = '#919399',
}
export enum ETagBackColor {
    test_lesson = '#D1E6E8',
    online_lesson = '#EEF4FB',
    selfpreparation_lesson = '#f9e9cc',
    assembly = '#E8D8F4',
    course_group_tag = '#EDEEF2',
}
export enum ETagIcons {
    test_lesson = 'pencil-l',
    online_lesson = 'webcam-l',
    selfpreparation_lesson = 'proktoring-s',
    assembly = 'user-s',
    course_group_tag = '',
}
